import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from "@sentry/react"
import './index.css'
import App from './App.tsx'
import { captureUTMParams } from './utils/utmCapture'
import { initLinkedInTracking } from './utils/linkedinTracking'

// Capture UTM parameters on initial page load
captureUTMParams()

// Sync tracking cookies (fbp, fbc, li_fat_id) for cross-app attribution
initLinkedInTracking()

Sentry.init({
  dsn: "https://e09273c4c076ef166d724ed9b657255c@o4510794749378560.ingest.de.sentry.io/4510794751082576",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
